<template>
  <b-row :class="rowClass">
    <b-col :class="videoColClass">
      <b-overlay :show="!show" variant="dark" :opacity="opacity" blur="0" @click="show = true; autoplay = true" style="cursor: pointer;">
        <template v-slot:overlay>
          <b-button variant="link">
            <img class="img-fluid w-75" src="/img/frontend/play.png" :style="`opacity:${1-opacity};`" />
          </b-button>
        </template>
        <b-aspect aspect="16:9">
          <video v-if="show" :src="video.video_url" type="mp4" :autoplay="autoplay" :poster="video.image_url" controls class="w-100" />
          <b-img v-if="!show" fluid :src="video.image_url" style="position: absolute; top: 0; left: 0; right: 0; bottom: 0; width: 100%;" />
        </b-aspect>
      </b-overlay>
    </b-col>
    <b-col :class="textColClass">
      <h5>
        <a :href="`#${video.id}`" class="anchor-hash">#</a>
        {{ video.name}}
      </h5>
      <p>
        {{ video.description }}
      </p>
      <p>
        <small class="text-muted" v-html="music"></small>
      </p>
    </b-col>
  </b-row>
</template>

<script>
  export default {
    props: {
      video: Object,
      rowClass: {
        type: String,
        default: null,
      },
      videoColClass: {
        type: String,
        default: 'col-md-6 order-md-1 col-12 order-2'
      },
      textColClass: {
        type: String,
        default: 'col-md-6 order-md-2 col-12 order-1'
      },
      opacity: {
        type: Number,
        default: 0.5
      },
    },
    data() {
      return {
        trans: trans,
        show: window.location.href.indexOf(this.video.id) >= 0,
        autoplay: window.location.href.indexOf(this.video.id) >= 0,
      }
    },
    computed: {
      music() {
        return trans('help_music_about')
          .replace(':name', this.video.music_name)
          .replace(':url', this.video.music_url)
      },
    },
    mounted() {
      window['video_' + this.video.id]
    },
  }
</script>